<template>
  <div class="banners-selector" :class="classList">
    <searchable-articles-list
      v-if="showSearchList"
      class="search-list"
      :query="query"
      @queryChange="handleQueryChange"
      :isLoading="isLoading"
      :value="selectableArticles"
      :disabled="disabled"
      :hasMoreArticles="hasMoreArticles"
      :hideSearch="hideSearch"
      @select="handleSelectArticle"
      @getMoreArticles="setupArticles"
      ref="searchableArticleList"
    ></searchable-articles-list>
    <selected-articles-list
      :disabled="disabled"
      class="selected-list"
      :value="value"
      @sortedValue="handleValueSorted"
      @remove="handleRemoveArticle"
      @removeAll="handleRemoveAllArticle"
    ></selected-articles-list>
  </div>
</template>

<script>
import differenceWith from "ramda/src/differenceWith";
import { Input } from "element-ui";
import ArticlesSelectorOption from "./ArticlesSelectorOption";
import SelectedArticlesList from "./SelectedArticlesList";
import SearchableArticlesList from "./SearchableArticlesList";
import ScButton from "@/lib/components/ScButton";
import { articleUseCase } from "../../../dependencies.js";
import { debounce } from "@/lib/util";

export default {
  components: {
    ArticlesSelectorOption,
    "el-input": Input,
    SelectedArticlesList,
    SearchableArticlesList,
    ScButton
  },
  props: ["initialArticles", "value", "disabled"],
  data() {
    return {
      query: "",
      hideSearch: true,
      allArticles: [],
      isLoading: false,
      page: 1,
      hasMoreArticles: false,
      totalArticles: 1
    };
  },
  computed: {
    selectableArticles() {
      return differenceWith(this.compareArticle, this.allArticles, this.value);
    },
    disabledRemoveButton() {
      return this.value.length === 0;
    },
    showSearchList() {
      return !this.disabled;
    },
    classList() {
      return { disabled: this.disabled };
    },
    queryParams() {
      return {
        searchText: this.query,
        page: this.page
      }
    }
  },
  watch: {
    query(oldVal, newVal) {
      this.watchQuery();
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupArticles();
    },
    async setupArticles() {
      if (this.allArticles.length === this.totalArticles) {
        this.hasMoreArticles = false;
        return;
      }
      const params = this.queryParams;
      const articles = await this.fetchArticles(params);
      this.page += 1;
      this.hasMoreArticles = true;

      const newArticles = articles.map(article => {
        const {
          id,
          title,
          content,
          category,
          imageUrl
        } = article;

        return {
          id,
          title,
          content,
          category,
          imageUrl
        };
      });

      this.allArticles = this.allArticles.concat(newArticles);
    },
    async fetchArticles(params = {}) {
      if (this.initialArticles) {
        return this.initialArticles;
      }

      this.isLoading = true;
      const { articleBanners, count } = await articleUseCase.listBanner(
        this.queryParams
      );

      this.isLoading = false;
      this.totalArticles = count;
      return articleBanners;
    },
    handleSelectArticle(article) {
      this.updateInput([...this.value, article]);
    },
    handleRemoveArticle(article) {
      this.updateInput(this.value.filter(({ id }) => article.id !== id));
    },
    handleRemoveAllArticle() {
      if (!confirm("คุณต้องการลบรายการใช่หรือไม่")) {
        return;
      }

      this.updateInput([]);
    },
    handleValueSorted(value) {
      this.updateInput(value);
    },
    updateInput(value) {
      this.$emit("input", value);
    },
    compareArticle(article, article2) {
      return article.id === article2.id;
    },
    handleQueryChange(value) {
      this.query = value;
    },
    watchQuery: debounce(function() {
      this.resetData();
      this.setupArticles();
      this.$refs.searchableArticleList.resetLoading();
    }, 1.5),
    resetData() {
      this.allArticles = [];
      this.totalArticles = 1;
      this.page = 1;
      this.hasMoreArticles = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.banners-selector {
  display: grid;
  grid-template-columns: 1fr 1fr;

  > .search-list {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  > .selected-list {
    border-left-width: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.banners-selector.disabled {
  display: block;

  > .selected-list {
    border-left-width: 1px;
    border-radius: $border-radius;
  }
}
</style>



// WEBPACK FOOTER //
// src/lib/components/ArticlesSelector/BannersSelector.vue